import { IconComponent } from '~harmony/components'

import IconAudiusLogoSVG from '../assets/icons/AudiusLogo.svg'
import IconAudiusLogoColorSVG from '../assets/icons/AudiusLogoColor.svg'
import IconAudiusLogoHorizontalSVG from '../assets/icons/AudiusLogoHorizontal.svg'
import IconAudiusLogoHorizontalColorSVG from '../assets/icons/AudiusLogoHorizontalColor.svg'
import IconAudiusLogoHorizontalColorNewSVG from '../assets/icons/AudiusLogoHorizontalColorNew.svg'
import IconAudiusLogoHorizontalNewSVG from '../assets/icons/AudiusLogoHorizontalNew.svg'
import IconAudiusLogoVerticalSVG from '../assets/icons/AudiusLogoVertical.svg'
import IconLogoWhiteBackgroundPng from '../assets/icons/AudiusLogoWhiteBg.png'
import IconDiscordSVG from '../assets/icons/Discord.svg'
import IconFacebookSVG from '../assets/icons/Facebook.svg'
import IconInstagramSVG from '../assets/icons/Instagram.svg'
import IconLogoLinkByStripeSVG from '../assets/icons/LinkByStripe.svg'
import IconLogoCircleSVG from '../assets/icons/LogoCircle.svg'
import IconLogoCircleETHSVG from '../assets/icons/LogoCircleETH.svg'
import IconLogoCircleSOLSVG from '../assets/icons/LogoCircleSOL.svg'
import IconLogoCircleSTRSVG from '../assets/icons/LogoCircleSTR.svg'
import IconLogoCircleUSDSVG from '../assets/icons/LogoCircleUSD.svg'
import LogoCircleUSDCPng from '../assets/icons/LogoCircleUSDC.jpg'
import IconLogoCircleUSDCSVG from '../assets/icons/LogoCircleUSDC.svg'
import IconPhantomSVG from '../assets/icons/LogoPhantom.svg'
import IconPhantomPlainSVG from '../assets/icons/LogoPhantomPlain.svg'
import IconSolanaSVG from '../assets/icons/LogoSolana.svg'
import IconMetamaskSVG from '../assets/icons/Metamask.svg'
import IconSnapChatSVG from '../assets/icons/SnapChat.svg'
import IconTelegramSVG from '../assets/icons/Telegram.svg'
import IconTikTokSVG from '../assets/icons/TikTok.svg'
import IconTwitterSVG from '../assets/icons/Twitter.svg'
import IconXSVG from '../assets/icons/X.svg'
import { createImageIcon } from '../utils/createImageIcon'

export const IconAudiusLogo = IconAudiusLogoSVG as IconComponent
export const IconAudiusLogoColor = IconAudiusLogoColorSVG as IconComponent
export const IconAudiusLogoHorizontal =
  IconAudiusLogoHorizontalSVG as IconComponent
export const IconAudiusLogoHorizontalColor =
  IconAudiusLogoHorizontalColorSVG as IconComponent
export const IconAudiusLogoHorizontalNew =
  IconAudiusLogoHorizontalNewSVG as IconComponent
export const IconAudiusLogoHorizontalColorNew =
  IconAudiusLogoHorizontalColorNewSVG as IconComponent
export const IconAudiusLogoVertical = IconAudiusLogoVerticalSVG as IconComponent
export const IconDiscord = IconDiscordSVG as IconComponent
export const IconFacebook = IconFacebookSVG as IconComponent
export const IconInstagram = IconInstagramSVG as IconComponent
export const IconLogoLinkByStripe = IconLogoLinkByStripeSVG as IconComponent
export const IconLogoCircle = IconLogoCircleSVG as IconComponent
export const IconLogoCircleETH = IconLogoCircleETHSVG as IconComponent
export const IconLogoCircleSOL = IconLogoCircleSOLSVG as IconComponent
export const IconLogoCircleSTR = IconLogoCircleSTRSVG as IconComponent
export const IconLogoCircleUSD = IconLogoCircleUSDSVG as IconComponent
export const IconLogoCircleUSDC = IconLogoCircleUSDCSVG as IconComponent
export const IconLogoCircleUSDCPng = createImageIcon(LogoCircleUSDCPng)
export const IconLogoWhiteBackground = createImageIcon(
  IconLogoWhiteBackgroundPng
)
export const IconPhantom = IconPhantomSVG as IconComponent
export const IconPhantomPlain = IconPhantomPlainSVG as IconComponent
export const IconSolana = IconSolanaSVG as IconComponent
export const IconMetamask = IconMetamaskSVG as IconComponent
export const IconSnapChat = IconSnapChatSVG as IconComponent
export const IconTelegram = IconTelegramSVG as IconComponent
export const IconTikTok = IconTikTokSVG as IconComponent
export const IconTwitter = IconTwitterSVG as IconComponent
export const IconX = IconXSVG as IconComponent
